import {planTypes ,trackingPlanTypes, WEBINAR_CATEGORY} from "@/common/constants";
import {get} from "lodash";
import { pageConfig } from '@/common/service/page-config';

const isMarketingWebinar100Enable = get(window, 'campaignFlags.isMarketingWebinar100Enable', true);

export default {
  key: planTypes['webinar'],
  data() {
    return {
      title: this.$t('billing.webinar.title'),
      subtitle: '',
      capacityKey: 'participants',
      planType: planTypes.WEBINAR,
      description: this.$t('billing.webinar.desc'),
      logo: require('@/assets/plans/webinar.svg'),
      totalLimitDesc: this.$t('billing.licences_limit_tips', ['Zoom Webinars', 'Zoom One']),
      supportCapacity: [
        (isMarketingWebinar100Enable && pageConfig.from === WEBINAR_CATEGORY.webinar100) ? 100 : null, 
        500,1000,3000,5000,10000
      ].filter(Boolean),
    }
  },
  computed: {
    trackingPlanKey() {
      return get(trackingPlanTypes, get(planTypes, this.planType));
    },
  }
};
